import React from 'react';
import { Hero } from '../src/components/sections/Hero';
import { WhatIs } from '../src/components/sections/WhatIs';
// import { Surgeon } from '../src/components/sections/Surgeon';
import { WhoAreWe } from '../src/components/sections/WhoAreWe';
import { Hospital } from '../src/components/sections/Hospital';
import { Devices } from '../src/components/sections/Devices';
import { Pricing } from '../src/components/sections/Pricing';
import { Process } from '../src/components/sections/Process';
import { Rehab } from '../src/components/sections/Rehab';
import { Support } from '../src/components/sections/Support';
import { CaseStudies } from '../src/components/sections/CaseStudies';
// import { Testimonials } from '../src/components/sections/Testimonials';
import { FAQ } from '../src/components/sections/FAQ';
import { Contact } from '../src/components/sections/Contact';
import { WhyUsBento } from '../src/components/sections/WhyUsBento';

export default function Page() {
  return (
    <>
      <Hero />
      <CaseStudies />
      <WhatIs />
      {/* <Surgeon /> */}
      <WhoAreWe />
      <Hospital />
      <Rehab />
      <Support />
      <Process />
      <Devices />
      <WhyUsBento />
      <Pricing />
      {/* <Testimonials /> */}
      <FAQ />
      <Contact />
    </>
  );
}